module.exports = __webpack_public_path__ + "img/3.45418a4e.png";